var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-body',[_c('TextEditor',{attrs:{"entity":_vm.entity,"label":"Navn","alias":"5ce68ef5d6c2910bb09c58a5","validate":true,"scope":"module"}}),_c('TextEditor',{attrs:{"entity":_vm.entity,"label":"Nummer","alias":"5ce693e7d6c2910bb09c58d8","validate":false,"scope":"module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }